import React, { useEffect, useState, useRef } from 'react';
import { Icon } from '@tencent/spaui';
import { currencyFormatV2 } from '@/pages/agency/utils/format.js';
import { reportSeasUserBehaviorCgi } from '@/api/operator/cgi/smb/common';
import { isOa } from '@/utils';
import WithPermission from '@/common/permissions/WithPermission';
import { formatePhoneTime } from '@/pages/saleTarget/common/constants.js';
import perms from '@/common/permissions/sale/perms';
import actions from '@/pages/saleTarget/api';
import drag from './drag';
import './index.less';
import dayjs from 'dayjs';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';

const page1 = '销售';
const page2 = '目标提醒面板';
const page3 = '';
const page4 = '';

const leftPartPosition = {
  left: 0,
  top: 0,
};

const position = {
  left: 0,
  top: 0,
};

let bordRes = null;

const Board = (props) => {
  if (isOa()) {
    return null;
  }

  const [detailData, setDetailData] = useState(null);
  const [showDetail, setShowDetail] = useState(false);
  const [minimizeShow, setMinimizeShow] = useState(false);
  const history = useHistory();
  const ref = useRef();
  const refXiao = useRef();

  const {
    performanceAdFeeOverviewVo = {},  // 广告费概览
    performanceOrderOverviewVo = {}, // 订单概览
    callDurationOverviewVo = {}, // 通话时长
    callNumberOverviewVo = {}, // 通话数量
    leadNumOverviewVo = {}, // 新增线索
    potentialNumOverviewVo = {}, // 新增商机
  } = detailData || {};

  useEffect(() => {
    if (!props.loginStatus?.oneOf([perms.PERM_SALES_TARGET_VIEW_SELF])) {
      console.log('没有查看我的目标的权限');
      return;
    }
    // 在首页，不拉接口
    if (history?.location?.pathname?.includes('/home')) {
      return;
    }
    if (bordRes) {
      return;
    }
    actions.myTargetOverView({
      // userId
      beginMonth: dayjs().format('YYYYMM'),
      endMonth: dayjs().format('YYYYMM'),
    }).then((res) => {
      const {
        performanceAdFeeOverviewVo, // 销售端广告费概览
        performanceOrderOverviewVo, // 销售端订单概览
        callDurationOverviewVo, // 通话时长
        callNumberOverviewVo, // 通话数量
        leadNumOverviewVo, // 新增线索
        potentialNumOverviewVo, // 新增商机
      } = res.data || {};
      bordRes = res.data;
      setDetailData({
        performanceAdFeeOverviewVo,
        performanceOrderOverviewVo,
        callDurationOverviewVo, // 通话时长
        callNumberOverviewVo, // 通话数量
        leadNumOverviewVo, // 新增线索
        potentialNumOverviewVo, // 新增商机
      });
    });
  }, [history?.location]);

  useEffect(() => {
    if (!ref.current) {
      return;
    }
    drag(ref.current);
  }, [ref.current, detailData]);

  useEffect(() => {
    if (!refXiao.current) {
      return;
    }
    drag(refXiao.current);
  }, [refXiao.current, minimizeShow]);

  const handleMouseDowm = (event, obj) => {
    const left = event.clientX;
    const top = event.clientY;
    obj.left = left;
    obj.top = top;
  };

  const handleMouseUp = (event) => {
    const left = event.clientX;
    const top = event.clientY;
    if (position.left === left && position.top === top) {
      setShowDetail(true);
      reportSeasUserBehaviorCgi({ data: {
        page1,
        page2,
        page3,
        page4,
        eventName: '销售业绩目标管理一期',
        behavior: '打开详情',
      } });
    }
  };

  const closeMinimize = (event) => {
    const left = event.clientX;
    const top = event.clientY;
    if (leftPartPosition.left === left && leftPartPosition.top === top) {
      setMinimizeShow(false);
    }
  };

  const handleMiniMouseUp = (event) => {
    event.preventDefault();
    event.stopPropagation();
    event.cancelBubble = true;
    const left = event.clientX;
    const top = event.clientY;
    if (position.left === left && position.top === top) {
      setMinimizeShow(true);
    }
  };

  const handleJumpDetail = (e) => {
    e.preventDefault();
    e.stopPropagation();
    e.cancelBubble = true;
    window.open('/ams/target/my');

    reportSeasUserBehaviorCgi({ data: {
      page1,
      page2,
      page3: '详情面板',
      page4,
      eventName: '销售业绩目标管理一期',
      behavior: '跳转我的目标',
    } });
  };

  const getPercent = (num) => {
    return `${Math.round((num || 0) * 10000) / 100}%`;
  };

  // if (!detailData) {
  //   return null;
  // }
  //
  // // 所有目标都没有 不展示这个组件
  // if (!callNumberOverviewVo?.targetNum
  //   && !callDurationOverviewVo?.targetNum
  //   && !leadNumOverviewVo?.targetNum
  //   && !potentialNumOverviewVo?.targetNum
  //   && !performanceOrderOverviewVo?.salesTargetOrderNumber
  //   && !performanceAdFeeOverviewVo?.salesTargetAdFee)
  // {
  //   return null;
  // }

  // 在首页，不展示
  if (history?.location?.pathname?.includes('/home')) {
    return null;
  }

  if (minimizeShow) {
    return (
      <WithPermission oneOf={[perms.PERM_SALES_TARGET_VIEW_SELF]} key='xiao'>
        <section
          ref={refXiao}
          onMouseDown={(e) => handleMouseDowm(e, leftPartPosition)}
          onMouseUp={closeMinimize}
          className="target-board-minimize"
          data-blockshuiping="true"
        >
          指标预警
          <span className="minimize-show-icon">{'<>'}</span>
        </section>
      </WithPermission>
    );
  }

  return (
    <WithPermission oneOf={[perms.PERM_SALES_TARGET_VIEW_SELF]} key='zhong'>
      <section
        onMouseDown={(e) => handleMouseDowm(e, position)}
        onMouseUp={handleMouseUp}
        className="target-board-container"
        ref={ref}
      >
        <div className="simple-board">
          <div className="minimize" onMouseUp={handleMiniMouseUp}>-</div>
          <section>
            <div className="title">今日指标</div>
            <div className="info-content">
              <span>通话量</span>
              <span className="success">{getPercent(callNumberOverviewVo?.ratio || 0)}</span>
            </div>
            <div className="info-content">
              <span>时长</span>
              <span className="success">{getPercent(callDurationOverviewVo?.ratio || 0)}</span>
            </div>
            <div className="info-content">
              <span>新增线索</span>
              <span className="success">{getPercent(leadNumOverviewVo?.ratio || 0)}</span>
            </div>
            <div className="info-content">
              <span>新增商机</span>
              <span className="success">{getPercent(potentialNumOverviewVo?.ratio || 0)}</span>
            </div>
          </section>
          <section>
            <div className="title">业绩目标</div>
            <div className="info-content">
              <span>订单量</span>
              <span className="success">{getPercent(performanceOrderOverviewVo?.orderProgressRatio || 0)}</span>
            </div>
            <div className="info-content">
              <span>广告费</span>
              <span className="success">{getPercent(performanceAdFeeOverviewVo?.adFeeProgressRatio || 0)}</span>
            </div>
          </section>
          {/* <section>*/}
          {/*  <div className="title">任务指标</div>*/}
          {/*  <div className="info-content">*/}
          {/*    <span>待办量</span>*/}
          {/*    <span className="success">9</span>*/}
          {/*  </div>*/}
          {/* </section>*/}
        </div>

        { !!showDetail && <div className="detail-info-container">
          <div className="line-container">
            <div>
              <div className="title">今日通话数量</div>
              <div className="num-content">
                <span className="success">{callNumberOverviewVo?.realNum}</span>/{callNumberOverviewVo?.targetNum} <span className="success">{getPercent(callNumberOverviewVo?.ratio)}</span>
              </div>
              <div className="range-content">
                {/* 环比 <span className="warning">-10%</span>团队平均 <span>38</span>*/}
              </div>
            </div>

            <div>
              <div className="title">今日通话时长</div>
              <div className="num-content">
                <span className="success">{formatePhoneTime(callDurationOverviewVo?.realNum)}</span>/{formatePhoneTime(callDurationOverviewVo?.targetNum)} <span className="success">{getPercent(callDurationOverviewVo?.ratio)}</span>
              </div>
              <div className="range-content">
                {/* 环比 <span className="warning">-10%</span>团队平均 <span>38</span>*/}
              </div>
            </div>
          </div>

          <div className="line-container">
            <div>
              <div className="title">今日新增线索</div>
              <div className="num-content">
                <span className="success">{leadNumOverviewVo?.realNum}</span>/{leadNumOverviewVo?.targetNum} <span className="success">{getPercent(leadNumOverviewVo?.ratio)}</span>
              </div>
              <div className="range-content">
                {/* 环比 <span className="warning">-10%</span>团队平均 <span>38</span>*/}
              </div>
            </div>

            <div>
              <div className="title">今日新增商机</div>
              <div className="num-content">
                <span className="success">{potentialNumOverviewVo?.realNum}</span>/{potentialNumOverviewVo?.targetNum} <span className="success">{getPercent(potentialNumOverviewVo?.ratio)}</span>
              </div>
              <div className="range-content">
                {/* 环比 <span className="warning">-10%</span>团队平均 <span>38</span>*/}
              </div>
            </div>
          </div>

          <div className="line-container border-none">
            <div>
              <div className="title">订单进展</div>
              <div className="num-content">
                <span className="success">
                  {currencyFormatV2(performanceOrderOverviewVo?.realOrderNumber || 0)}</span>/{currencyFormatV2(performanceOrderOverviewVo?.salesTargetOrderNumber || 0)} <span className="success">{getPercent(performanceOrderOverviewVo?.orderProgressRatio || 0)}</span>
              </div>
              <div className="range-content">
                {/* 环比 <span className="warning">-10%</span>团队平均 <span>38</span>*/}
              </div>
            </div>

            <div>
              <div className="title">广告费进展</div>
              <div className="num-content">
                <span className="success">{currencyFormatV2(performanceAdFeeOverviewVo?.realAdFee / 100)}</span>/{currencyFormatV2(performanceAdFeeOverviewVo?.salesTargetAdFee / 100)} <span className="success">{getPercent(performanceAdFeeOverviewVo?.adFeeProgressRatio)}</span>
              </div>
              <div className="range-content">
                {/* 环比 <span className="warning">-10%</span>团队平均 <span>38</span>*/}
              </div>
            </div>
          </div>

          <div className="close" onClick={() => setShowDetail(false)}>
            <Icon name='close-normal-outlined' />
          </div>
          <div className="detail" onClick={handleJumpDetail}>
            查看详情<Icon name='right-arrow-outlined' />
          </div>
        </div>}
      </section>
    </WithPermission>
  );
};

function mapStateToProps(state) {
  const loginStatus = state.loginStatus;
  return {
    loginStatus,
  };
}

export default connect(mapStateToProps)(Board);
